import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from 'src/components/i18n';

const languageOptions = [
    {
        key: 'de',
        value: 'de',
        text: 'Deutsch'
    }, {
        key: 'en',
        value: 'en',
        text: 'English'
    }, {
        key: 'es',
        value: 'es',
        text: 'Español'
    }, {
        key: 'fr',
        value: 'fr',
        text: 'Français'
    },
];

const ChangeLanguageSettings = props => {
    const currentLanguage = languageOptions.find(obj => obj.value === localStorage.getItem("i18nextLng") || obj.value === 'en').value;
    const { t } = useTranslation();
    const [language, setLanguage] = React.useState(currentLanguage);

    const handleChange = (event) => {
        setLanguage(event.target.value);
        i18n.changeLanguage(event.target.value);
    }

    return (
        <FormControl fullWidth>
            <InputLabel id="language-select-label">{t("Language Preference")}</InputLabel>
            <Select
                labelId="language-select-label"
                id="language-select"
                value={language}
                label={t("Language Preference")}
                onChange={handleChange}
            >
                {languageOptions.map((option) => (
                    <MenuItem key={option.key} value={option.value}>
                        {option.text}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

ChangeLanguageSettings.propTypes = {}

export default ChangeLanguageSettings
